import { createFileRoute } from "@tanstack/react-router";
import { SubPage } from "@/components/sub-page";

const URL = "https://mine-class.com/legal/seguridad-informacion";

export const Route = createFileRoute("/legal/seguridad-informacion")({
  head: () => ({
    meta: [
      { title: "Política de Seguridad de la Información | Mine Class" },
      {
        name: "description",
        content:
          "Política general de seguridad de la información de Mine Class SpA (Requisito 5.2, ISO 27001): compromiso de la alta dirección y mejora continua.",
      },
      { property: "og:title", content: "Política de Seguridad de la Información | Mine Class" },
      { property: "og:description", content: "Cómo Mine Class SpA gestiona la seguridad de la información conforme a ISO 27001." },
      { property: "og:type", content: "article" },
      { property: "og:url", content: URL },
      { name: "twitter:card", content: "summary" },
    ],
    links: [{ rel: "canonical", href: URL }],
  }),
  component: Page,
});

function Page() {
  return (
    <SubPage
      eyebrow="Legal"
      title="Política general de seguridad de la información"
      intro="Requisito 5.2"
    >
      <p>
        La Seguridad de la Información en Mine Class SpA es parte fundamental del negocio para así entregar confianza a nuestros clientes y usuarios sobre las tecnologías de la información que operamos. La data, con base en nuestra clasificación de la información, es gestionada con los más altos estándares según las mejores prácticas disponibles en el mercado, lo cual es una base para nuestro crecimiento y sustentabilidad organizacional.
      </p>
      <p>
        La Seguridad de la Información en Mine Class SpA es posible dado el compromiso de la alta dirección promoviendo una cultura de mejora continua, facilitando los recursos y herramientas necesarias.
      </p>
      <p>
        La alta dirección entiende y atiende la importancia y beneficios de mantenerse en cumplimiento, no solo con los requerimientos de ISO 27001 y mejores prácticas de seguridad, sino además con otros requisitos legales, contractuales y gubernamentales relevantes para el contexto de la organización.
      </p>
      <p>
        En Mine Class SpA nuestras políticas y procedimientos en cuanto a la Seguridad de la Información son del conocimiento general de los empleados, cuando aplique. En la medida de lo posible y con base al Plan de Comunicación del SGSI definido, nuestras partes interesadas clave serán informadas de nuestros lineamientos y mejores prácticas.
      </p>
    </SubPage>
  );
}
